<template>
  <div style="height: 100%;">
    <div class="heading">
      <h1>{{heading.title}}</h1>
      <h5>{{heading.subtitle}}</h5>
      <v-divider />
    </div>
    <v-container fluid grid-list-md style="height: calc(100% - 7rem - 40px);">
      <router-view/>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headings: [
        {
          title: 'Administration',
          subtitle: 'Control all aspects of the Clinical Assessment System.',
          path: '/admin',
        },
        {
          title: 'Clinic',
          subtitle: 'Create/modify the clinical procedure quizes.',
          path: '/clinic',
        },
        {
          title: 'Grading',
          subtitle: 'Grade students clinical procedure quizes.',
          path: '/grading',
        },
        {
          title: 'History',
          subtitle: 'The complete history of your procedures.',
          path: '/history',
        },
        {
          title: 'Marking Heuristic',
          subtitle: 'Heuristic used for grading clinical sessions.',
          path: '/heuristic',
        },
        {
          title: 'Report',
          subtitle: 'The complete history of your results can be accessed here.',
          path: '/',
        },
      ],
    };
  },
  computed: {
    heading() { return this.headings.find(h => this.$route.path.indexOf(h.path) !== -1) || {}; },
  },
};
</script>

<style lang="stylus" scoped>
.heading
  text-align center
  padding-top: 2em
  h1
    font-size 3rem
    font-weight 300
  h5
    font-size 1.5rem
    font-weight 300
    padding-bottom 0.5em
</style>
